import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "../setup";
import Noti from "../../../view/components/general/noti";
import {PatientAllergyService} from "../../../services/requests/ehr/patientAllergy";

const useGetPatientAllergies = (params: any ,modalName?: boolean) => {
  return useQuery({
    queryKey: ["getPatientAllergies", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return PatientAllergyService.getPatientAllergiesList(params);
    },
    enabled: modalName ?? true
  });
}

const useGetPatientAllergy = () => {
  return useMutation({
    mutationFn: PatientAllergyService.getPatientAllergy,
  })
}

const useAddPatientAllergy = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: PatientAllergyService.addPatientAllergy,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getPatientAllergies"] })
          onSuccess();
        }
      })
    },
  })
}

const useDeletePatientAllergy = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: PatientAllergyService.deletePatientAllergy,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getPatientAllergies"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetPatientAllergies,
  useGetPatientAllergy,
  useAddPatientAllergy,
  useDeletePatientAllergy
}
